<script setup lang="ts">
import { Btn, Dialog, FormFlow } from '@bagelink/vue'
import { useNewsletter } from '@/composables/useNewsletter'

// Single shared newsletter-subscribe dialog. Rendered once (by BlockNav); any
// block opens it via `useNewsletter().openNewsletter()`.
const { isOpen, formData, state, schema, loadError, submitNewsletter } = useNewsletter()
</script>

<template>
	<Dialog :open="isOpen" width="s" @update:open="(v: boolean) => (isOpen = v)">
		<div class="txt-center px-1 pb-05 -mt-1">
			<h2 class="txt18 italic m-0 line-height-13 pb-1 balance">
				Stay updated with the latest scholarship
			</h2>
			<template v-if="state === 'success'">
				<p class="txt15 color-gray-70 pb-1">Thank you for subscribing!</p>
				<Btn color="primary" value="Close" @click="isOpen = false" />
			</template>
			<template v-else>
				<p v-if="loadError" class="txt13 color-red">{{ loadError }}</p>
				<FormFlow
					v-else-if="schema"
					v-model="formData"
					:schema="schema"
					:on-submit="submitNewsletter"
				>
					<template #submit="{ formState }">
						<Btn
							type="submit"
							color="primary"
							:loading="formState === 'submitting'"
							value="Subscribe"
							class="rounded"
							full-width
						/>
					</template>
				</FormFlow>
				<p v-if="state === 'error'" class="txt13 color-red pt-1">
					Something went wrong. Please try again.
				</p>
			</template>
		</div>
	</Dialog>
</template>
